/* tslint:disable */
/* eslint-disable */
/**
 * MeerSec Connect Portal (MSCP) API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AssetsControllerFindAllCidr200Response
 */
export interface AssetsControllerFindAllCidr200Response {
    /**
     * 
     * @type {Array<CidrResponseDto>}
     * @memberof AssetsControllerFindAllCidr200Response
     */
    'items': Array<CidrResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof AssetsControllerFindAllCidr200Response
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface AssetsControllerFindAllDnsRecords200Response
 */
export interface AssetsControllerFindAllDnsRecords200Response {
    /**
     * 
     * @type {Array<DnsRecordsResponseDto>}
     * @memberof AssetsControllerFindAllDnsRecords200Response
     */
    'items': Array<DnsRecordsResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof AssetsControllerFindAllDnsRecords200Response
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface AssetsControllerFindAllDomain200Response
 */
export interface AssetsControllerFindAllDomain200Response {
    /**
     * 
     * @type {Array<DomainResponseDto>}
     * @memberof AssetsControllerFindAllDomain200Response
     */
    'items': Array<DomainResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof AssetsControllerFindAllDomain200Response
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface AssetsControllerFindAllIp200Response
 */
export interface AssetsControllerFindAllIp200Response {
    /**
     * 
     * @type {Array<IpResponseDto>}
     * @memberof AssetsControllerFindAllIp200Response
     */
    'items': Array<IpResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof AssetsControllerFindAllIp200Response
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface AssetsControllerFindAllX509Certificates200Response
 */
export interface AssetsControllerFindAllX509Certificates200Response {
    /**
     * 
     * @type {Array<X509CertificateResponseDto>}
     * @memberof AssetsControllerFindAllX509Certificates200Response
     */
    'items': Array<X509CertificateResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof AssetsControllerFindAllX509Certificates200Response
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface BatchConfigurationDto
 */
export interface BatchConfigurationDto {
    /**
     * Array of configurations to update
     * @type {Array<BatchConfigurationItemDto>}
     * @memberof BatchConfigurationDto
     */
    'configurations': Array<BatchConfigurationItemDto>;
}
/**
 * 
 * @export
 * @interface BatchConfigurationItemDto
 */
export interface BatchConfigurationItemDto {
    /**
     * Configuration key to set
     * @type {string}
     * @memberof BatchConfigurationItemDto
     */
    'configKey': BatchConfigurationItemDtoConfigKeyEnum;
    /**
     * Configuration value to set
     * @type {object}
     * @memberof BatchConfigurationItemDto
     */
    'configValue': object;
}

export const BatchConfigurationItemDtoConfigKeyEnum = {
    DiscordNotificationHookUrl: 'discord_notification_hook_url',
    DiscordNotificationEnable: 'discord_notification_enable'
} as const;

export type BatchConfigurationItemDtoConfigKeyEnum = typeof BatchConfigurationItemDtoConfigKeyEnum[keyof typeof BatchConfigurationItemDtoConfigKeyEnum];

/**
 * 
 * @export
 * @interface CADistributionDto
 */
export interface CADistributionDto {
    /**
     * Name of the Certificate Authority
     * @type {string}
     * @memberof CADistributionDto
     */
    'caName': string;
    /**
     * Number of certificates issued by this CA
     * @type {number}
     * @memberof CADistributionDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ChangeRecordBasicResponseDto
 */
export interface ChangeRecordBasicResponseDto {
    /**
     * Unique identifier for the change record
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'id': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'orgId': string;
    /**
     * Type of asset that changed (e.g., DNS, SSL, IP)
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'assetType': string;
    /**
     * Type of change (e.g., CREATED, UPDATED, DELETED)
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'changeType': string;
    /**
     * Timestamp when the change was detected
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'detectionTime': string;
    /**
     * Current status of the change record
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'status': ChangeRecordBasicResponseDtoStatusEnum;
    /**
     * Classification of the change
     * @type {Array<string>}
     * @memberof ChangeRecordBasicResponseDto
     */
    'classification': Array<ChangeRecordBasicResponseDtoClassificationEnum>;
    /**
     * 
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'notes'?: string;
    /**
     * Timestamp when the record was created
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'createdAt': string;
    /**
     * Timestamp when the record was last updated
     * @type {string}
     * @memberof ChangeRecordBasicResponseDto
     */
    'updatedAt': string;
}

export const ChangeRecordBasicResponseDtoStatusEnum = {
    Open: 'open',
    Closed: 'closed',
    All: 'all'
} as const;

export type ChangeRecordBasicResponseDtoStatusEnum = typeof ChangeRecordBasicResponseDtoStatusEnum[keyof typeof ChangeRecordBasicResponseDtoStatusEnum];
export const ChangeRecordBasicResponseDtoClassificationEnum = {
    Unauthorized: 'unauthorized',
    FalsePositive: 'false-positive',
    TruePositive: 'true-positive',
    Testing: 'testing',
    PreAuthorized: 'pre-authorized',
    PostAuthorized: 'post-authorized',
    EmergencyAuthorized: 'emergency-authorized',
    SysSuperseded: 'sys-superseded'
} as const;

export type ChangeRecordBasicResponseDtoClassificationEnum = typeof ChangeRecordBasicResponseDtoClassificationEnum[keyof typeof ChangeRecordBasicResponseDtoClassificationEnum];

/**
 * 
 * @export
 * @interface ChangeRecordResponseDto
 */
export interface ChangeRecordResponseDto {
    /**
     * Unique identifier for the change record
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'id': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'orgId': string;
    /**
     * Organization name
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'organizationName': string;
    /**
     * Type of asset (e.g., DNS, Certificate, Port)
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'assetType': string;
    /**
     * Unique identifier for the asset across scans
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'assetIdentifier': string;
    /**
     * Hash of the asset state before change
     * @type {object}
     * @memberof ChangeRecordResponseDto
     */
    'previousStateHash'?: object;
    /**
     * Hash of the asset state after change
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'currentStateHash': string;
    /**
     * Type of change (e.g., New, Modified, Deleted)
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'changeType': string;
    /**
     * How the change was detected
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'detectionMethod': string;
    /**
     * Timestamp when the change was detected
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'detectionTime': string;
    /**
     * Brief title describing the change
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'changeTitle': string;
    /**
     * Detailed summary of what changed
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'changeSummary': string;
    /**
     * Current status of the change record
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'status': string;
    /**
     * Classification statuses of the change record (can have multiple)
     * @type {Array<string>}
     * @memberof ChangeRecordResponseDto
     */
    'classification': Array<ChangeRecordResponseDtoClassificationEnum>;
    /**
     * Name of the user who last changed the status
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'statusChangedByName'?: string;
    /**
     * Timestamp when the status was last changed
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'statusChangedAt'?: string;
    /**
     * Reason for the status change
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'statusChangeReason'?: string;
    /**
     * Date when the record was created
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'createdAt': string;
    /**
     * Date when the record was last updated
     * @type {string}
     * @memberof ChangeRecordResponseDto
     */
    'updatedAt': string;
}

export const ChangeRecordResponseDtoClassificationEnum = {
    Unauthorized: 'unauthorized',
    FalsePositive: 'false-positive',
    TruePositive: 'true-positive',
    Testing: 'testing',
    PreAuthorized: 'pre-authorized',
    PostAuthorized: 'post-authorized',
    EmergencyAuthorized: 'emergency-authorized',
    SysSuperseded: 'sys-superseded'
} as const;

export type ChangeRecordResponseDtoClassificationEnum = typeof ChangeRecordResponseDtoClassificationEnum[keyof typeof ChangeRecordResponseDtoClassificationEnum];

/**
 * 
 * @export
 * @interface ChangeRecordsControllerFindAll200Response
 */
export interface ChangeRecordsControllerFindAll200Response {
    /**
     * 
     * @type {Array<ChangeRecordResponseDto>}
     * @memberof ChangeRecordsControllerFindAll200Response
     */
    'items': Array<ChangeRecordResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof ChangeRecordsControllerFindAll200Response
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface ChangeRecordsControllerGetChangeDetails200Response
 */
export interface ChangeRecordsControllerGetChangeDetails200Response {
    /**
     * Unique identifier for the change record
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'id': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'orgId': string;
    /**
     * Organization name
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'organizationName': string;
    /**
     * Type of asset (e.g., DNS, Certificate, Port)
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'assetType': string;
    /**
     * Unique identifier for the asset across scans
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'assetIdentifier': string;
    /**
     * Hash of the asset state before change
     * @type {object}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'previousStateHash'?: object;
    /**
     * Hash of the asset state after change
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'currentStateHash': string;
    /**
     * Type of change (e.g., New, Modified, Deleted)
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'changeType': string;
    /**
     * How the change was detected
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'detectionMethod': string;
    /**
     * Timestamp when the change was detected
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'detectionTime': string;
    /**
     * Brief title describing the change
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'changeTitle': string;
    /**
     * Detailed summary of what changed
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'changeSummary': string;
    /**
     * Current status of the change record
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'status': string;
    /**
     * Classification statuses of the change record (can have multiple)
     * @type {Array<string>}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'classification': Array<ChangeRecordsControllerGetChangeDetails200ResponseClassificationEnum>;
    /**
     * Name of the user who last changed the status
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'statusChangedByName'?: string;
    /**
     * Timestamp when the status was last changed
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'statusChangedAt'?: string;
    /**
     * Reason for the status change
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'statusChangeReason'?: string;
    /**
     * Date when the record was created
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'createdAt': string;
    /**
     * Date when the record was last updated
     * @type {string}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'updatedAt': string;
    /**
     * 
     * @type {ChangeRecordsControllerGetChangeDetails200ResponseAllOfAssetSpecificDetails}
     * @memberof ChangeRecordsControllerGetChangeDetails200Response
     */
    'assetSpecificDetails'?: ChangeRecordsControllerGetChangeDetails200ResponseAllOfAssetSpecificDetails | null;
}

export const ChangeRecordsControllerGetChangeDetails200ResponseClassificationEnum = {
    Unauthorized: 'unauthorized',
    FalsePositive: 'false-positive',
    TruePositive: 'true-positive',
    Testing: 'testing',
    PreAuthorized: 'pre-authorized',
    PostAuthorized: 'post-authorized',
    EmergencyAuthorized: 'emergency-authorized',
    SysSuperseded: 'sys-superseded'
} as const;

export type ChangeRecordsControllerGetChangeDetails200ResponseClassificationEnum = typeof ChangeRecordsControllerGetChangeDetails200ResponseClassificationEnum[keyof typeof ChangeRecordsControllerGetChangeDetails200ResponseClassificationEnum];

/**
 * @type ChangeRecordsControllerGetChangeDetails200ResponseAllOfAssetSpecificDetails
 * @export
 */
export type ChangeRecordsControllerGetChangeDetails200ResponseAllOfAssetSpecificDetails = DnsRecordsChangeDetailsResponseDto | InternetServiceChangeDetailsResponseDto | SSLCertificateChangeDetailsResponseDto | X509CertificateChangeDetailsResponseDto;

/**
 * 
 * @export
 * @interface CidrResponseDto
 */
export interface CidrResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CidrResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CidrResponseDto
     */
    'notes': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CidrResponseDto
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CidrResponseDto
     */
    'orgId': string;
    /**
     * 
     * @type {OrganizationBasicResponseDto}
     * @memberof CidrResponseDto
     */
    'organization': OrganizationBasicResponseDto;
    /**
     * 
     * @type {string}
     * @memberof CidrResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CidrResponseDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CidrResponseDto
     */
    'title': string;
    /**
     * CIDR notation for network address range (e.g., 192.168.1.0/24)
     * @type {string}
     * @memberof CidrResponseDto
     */
    'cidr': string;
    /**
     * Enable ASM monitoring for this CIDR range (changes, vulnerabilities, threats)
     * @type {boolean}
     * @memberof CidrResponseDto
     */
    'monitorEnabled': boolean;
}
/**
 * 
 * @export
 * @interface ConfigurationActionResponseDto
 */
export interface ConfigurationActionResponseDto {
    /**
     * Success status of the operation
     * @type {boolean}
     * @memberof ConfigurationActionResponseDto
     */
    'success': boolean;
    /**
     * Response message
     * @type {string}
     * @memberof ConfigurationActionResponseDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ConfigurationControllerSetConfigurationRequest
 */
export interface ConfigurationControllerSetConfigurationRequest {
    /**
     * The configuration value
     * @type {any}
     * @memberof ConfigurationControllerSetConfigurationRequest
     */
    'value': any;
}
/**
 * 
 * @export
 * @interface CreateCidrDto
 */
export interface CreateCidrDto {
    /**
     * notes of the asset
     * @type {string}
     * @memberof CreateCidrDto
     */
    'notes': string;
    /**
     * tags of the asset
     * @type {Array<string>}
     * @memberof CreateCidrDto
     */
    'tags': Array<string>;
    /**
     * cidr title
     * @type {string}
     * @memberof CreateCidrDto
     */
    'title': string;
    /**
     * cidr value
     * @type {string}
     * @memberof CreateCidrDto
     */
    'cidr': string;
    /**
     * Enable ASM monitoring for this CIDR range (changes, vulnerabilities, threats)
     * @type {boolean}
     * @memberof CreateCidrDto
     */
    'monitorEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateDomainDto
 */
export interface CreateDomainDto {
    /**
     * notes of the asset
     * @type {string}
     * @memberof CreateDomainDto
     */
    'notes': string;
    /**
     * tags of the asset
     * @type {Array<string>}
     * @memberof CreateDomainDto
     */
    'tags': Array<string>;
    /**
     * domain name
     * @type {string}
     * @memberof CreateDomainDto
     */
    'domain': string;
    /**
     * registrar
     * @type {string}
     * @memberof CreateDomainDto
     */
    'registrar': string;
    /**
     * Enable ASM monitoring for this domain (changes, vulnerabilities, DPM scam detection)
     * @type {boolean}
     * @memberof CreateDomainDto
     */
    'monitorEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateIpDto
 */
export interface CreateIpDto {
    /**
     * notes of the asset
     * @type {string}
     * @memberof CreateIpDto
     */
    'notes': string;
    /**
     * tags of the asset
     * @type {Array<string>}
     * @memberof CreateIpDto
     */
    'tags': Array<string>;
    /**
     * IP address
     * @type {string}
     * @memberof CreateIpDto
     */
    'ip': string;
    /**
     * Enable ASM monitoring for this IP asset (changes, vulnerabilities, threats)
     * @type {boolean}
     * @memberof CreateIpDto
     */
    'monitorEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface DiscoveriesControllerFindAllInternetServices200Response
 */
export interface DiscoveriesControllerFindAllInternetServices200Response {
    /**
     * 
     * @type {Array<InternetServiceResponseDto>}
     * @memberof DiscoveriesControllerFindAllInternetServices200Response
     */
    'items': Array<InternetServiceResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof DiscoveriesControllerFindAllInternetServices200Response
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface DnsRecordValueDto
 */
export interface DnsRecordValueDto {
    /**
     * The value of the DNS record
     * @type {string}
     * @memberof DnsRecordValueDto
     */
    'value': string;
    /**
     * Time to live in seconds
     * @type {number}
     * @memberof DnsRecordValueDto
     */
    'ttl': number;
}
/**
 * 
 * @export
 * @interface DnsRecordsChangeDetailsResponseDto
 */
export interface DnsRecordsChangeDetailsResponseDto {
    /**
     * ID of the associated change record
     * @type {string}
     * @memberof DnsRecordsChangeDetailsResponseDto
     */
    'changeId': string;
    /**
     * 
     * @type {ChangeRecordBasicResponseDto}
     * @memberof DnsRecordsChangeDetailsResponseDto
     */
    'changeRecord': ChangeRecordBasicResponseDto;
    /**
     * DNS record type (e.g., A, AAAA, CNAME, MX, etc.)
     * @type {string}
     * @memberof DnsRecordsChangeDetailsResponseDto
     */
    'recordType': string;
    /**
     * DNS record name (subdomain or @ for root)
     * @type {string}
     * @memberof DnsRecordsChangeDetailsResponseDto
     */
    'domainName': string;
    /**
     * Previous DNS record values
     * @type {Array<DnsRecordValueDto>}
     * @memberof DnsRecordsChangeDetailsResponseDto
     */
    'previousValues'?: Array<DnsRecordValueDto>;
    /**
     * New DNS record values
     * @type {Array<DnsRecordValueDto>}
     * @memberof DnsRecordsChangeDetailsResponseDto
     */
    'newValues'?: Array<DnsRecordValueDto>;
}
/**
 * 
 * @export
 * @interface DnsRecordsResponseDto
 */
export interface DnsRecordsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DnsRecordsResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DnsRecordsResponseDto
     */
    'orgId': string;
    /**
     * 
     * @type {OrganizationResponseDto}
     * @memberof DnsRecordsResponseDto
     */
    'organization': OrganizationResponseDto;
    /**
     * DNS record type (A, AAAA, CNAME, MX, etc.)
     * @type {string}
     * @memberof DnsRecordsResponseDto
     */
    'recordType': string;
    /**
     * DNS record name
     * @type {string}
     * @memberof DnsRecordsResponseDto
     */
    'domainName': string;
    /**
     * New DNS record values
     * @type {Array<DnsRecordValueDto>}
     * @memberof DnsRecordsResponseDto
     */
    'values'?: Array<DnsRecordValueDto>;
    /**
     * 
     * @type {string}
     * @memberof DnsRecordsResponseDto
     */
    'notes'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DnsRecordsResponseDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DnsRecordsResponseDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DnsRecordsResponseDto
     */
    'monitorEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DnsRecordsResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DnsRecordsResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface DomainBasicResponseDto
 */
export interface DomainBasicResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DomainBasicResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DomainBasicResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DomainBasicResponseDto
     */
    'orgId': string;
    /**
     * 
     * @type {OrganizationBasicResponseDto}
     * @memberof DomainBasicResponseDto
     */
    'organization': OrganizationBasicResponseDto;
    /**
     * 
     * @type {string}
     * @memberof DomainBasicResponseDto
     */
    'notes'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DomainBasicResponseDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DomainBasicResponseDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DomainBasicResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DomainBasicResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface DomainResponseDto
 */
export interface DomainResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DomainResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DomainResponseDto
     */
    'notes': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DomainResponseDto
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DomainResponseDto
     */
    'orgId': string;
    /**
     * 
     * @type {OrganizationBasicResponseDto}
     * @memberof DomainResponseDto
     */
    'organization': OrganizationBasicResponseDto;
    /**
     * 
     * @type {string}
     * @memberof DomainResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DomainResponseDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof DomainResponseDto
     */
    'domain': string;
    /**
     * Enable ASM monitoring for this domain (changes, vulnerabilities, DPM scam detection)
     * @type {boolean}
     * @memberof DomainResponseDto
     */
    'monitorEnabled': boolean;
    /**
     * Number of domain levels (e.g., 2 for example.com, 3 for sub.example.com)
     * @type {number}
     * @memberof DomainResponseDto
     */
    'domainLevel': number;
    /**
     * 
     * @type {string}
     * @memberof DomainResponseDto
     */
    'registrar': string;
}
/**
 * 
 * @export
 * @interface ExpiringCertificateDto
 */
export interface ExpiringCertificateDto {
    /**
     * Certificate ID
     * @type {string}
     * @memberof ExpiringCertificateDto
     */
    'id': string;
    /**
     * Common name of the certificate
     * @type {string}
     * @memberof ExpiringCertificateDto
     */
    'commonName': string;
    /**
     * Expiry date in ISO format
     * @type {string}
     * @memberof ExpiringCertificateDto
     */
    'expiryDate': string;
    /**
     * Issuer name
     * @type {string}
     * @memberof ExpiringCertificateDto
     */
    'issuer': string;
    /**
     * Domain name
     * @type {string}
     * @memberof ExpiringCertificateDto
     */
    'domain': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExpiryStatus = {
    Valid: 'valid',
    Expiring: 'expiring',
    Expired: 'expired',
    Unknown: 'unknown'
} as const;

export type ExpiryStatus = typeof ExpiryStatus[keyof typeof ExpiryStatus];


/**
 * 
 * @export
 * @interface ExpiryStatusCountDto
 */
export interface ExpiryStatusCountDto {
    /**
     * 
     * @type {ExpiryStatus}
     * @memberof ExpiryStatusCountDto
     */
    'status': ExpiryStatus;
    /**
     * Number of certificates with this status
     * @type {number}
     * @memberof ExpiryStatusCountDto
     */
    'count': number;
}


/**
 * 
 * @export
 * @interface InternetServiceChangeDetailsResponseDto
 */
export interface InternetServiceChangeDetailsResponseDto {
    /**
     * ID of the associated change record
     * @type {string}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'changeRecordId': string;
    /**
     * IP address where the service was detected
     * @type {string}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'ipAddress': string;
    /**
     * Service name (e.g., http, https, ssh)
     * @type {string}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'serviceName': string;
    /**
     * Service protocol (e.g., tcp, udp)
     * @type {string}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'serviceProtocol': string;
    /**
     * Service port number
     * @type {number}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'servicePort': number;
    /**
     * Previous service fingerprint (if changed)
     * @type {object}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'previousFingerprint': object | null;
    /**
     * New service fingerprint
     * @type {object}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'newFingerprint': object | null;
    /**
     * Previous service tunnel (if changed)
     * @type {object}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'previousTunnel': object | null;
    /**
     * New service tunnel
     * @type {object}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'newTunnel': object | null;
    /**
     * Previous confidence level (if changed)
     * @type {object}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'previousConfidence': object | null;
    /**
     * New confidence level
     * @type {object}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'newConfidence': object | null;
    /**
     * Source of the service information (e.g., nmap, manual, api)
     * @type {object}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'source': object | null;
    /**
     * Detection timestamp
     * @type {string}
     * @memberof InternetServiceChangeDetailsResponseDto
     */
    'detectionTime': string;
}
/**
 * 
 * @export
 * @interface InternetServiceResponseDto
 */
export interface InternetServiceResponseDto {
    /**
     * Unique identifier for the service record
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'id': string;
    /**
     * Organization ID this service belongs to
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'orgId': string;
    /**
     * IP address where this service was discovered
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'ipAddress': string;
    /**
     * Port number where the service is running
     * @type {number}
     * @memberof InternetServiceResponseDto
     */
    'servicePort': number;
    /**
     * Name of the service (e.g., http, https, ssh)
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'serviceName': string;
    /**
     * Protocol of the service (e.g., tcp, udp)
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'serviceProtocol': string;
    /**
     * Service fingerprint information
     * @type {object}
     * @memberof InternetServiceResponseDto
     */
    'serviceFingerprint': object | null;
    /**
     * Service tunnel type (e.g., ssl, ssh)
     * @type {object}
     * @memberof InternetServiceResponseDto
     */
    'serviceTunnel': object | null;
    /**
     * Confidence level of service detection
     * @type {object}
     * @memberof InternetServiceResponseDto
     */
    'serviceConfidence': object | null;
    /**
     * Date when this service was first observed
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'firstSeen': string;
    /**
     * Date when this service was most recently observed
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'lastSeen': string;
    /**
     * Array of tags for categorizing and filtering services
     * @type {Array<string>}
     * @memberof InternetServiceResponseDto
     */
    'tags': Array<string>;
    /**
     * Whether this service should be monitored for changes
     * @type {boolean}
     * @memberof InternetServiceResponseDto
     */
    'monitorEnabled': boolean;
    /**
     * Date when the service record was created
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'createdAt': string;
    /**
     * Date when the service record was last updated
     * @type {string}
     * @memberof InternetServiceResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface InternetServiceStatsResponseDto
 */
export interface InternetServiceStatsResponseDto {
    /**
     * Top ports by usage
     * @type {Array<PortStatDto>}
     * @memberof InternetServiceStatsResponseDto
     */
    'topPorts': Array<PortStatDto>;
    /**
     * Total count of distinct ports
     * @type {number}
     * @memberof InternetServiceStatsResponseDto
     */
    'totalDistinctPorts': number;
    /**
     * Top services by usage
     * @type {Array<ServiceStatDto>}
     * @memberof InternetServiceStatsResponseDto
     */
    'topServices': Array<ServiceStatDto>;
    /**
     * Total count of distinct services
     * @type {number}
     * @memberof InternetServiceStatsResponseDto
     */
    'totalDistinctServices': number;
    /**
     * Top IP addresses by service count
     * @type {Array<IpStatDto>}
     * @memberof InternetServiceStatsResponseDto
     */
    'topIps': Array<IpStatDto>;
    /**
     * Total count of distinct IP addresses
     * @type {number}
     * @memberof InternetServiceStatsResponseDto
     */
    'totalDistinctIps': number;
}
/**
 * 
 * @export
 * @interface IpResponseDto
 */
export interface IpResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IpResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IpResponseDto
     */
    'notes': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IpResponseDto
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IpResponseDto
     */
    'orgId': string;
    /**
     * 
     * @type {OrganizationBasicResponseDto}
     * @memberof IpResponseDto
     */
    'organization': OrganizationBasicResponseDto;
    /**
     * 
     * @type {string}
     * @memberof IpResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof IpResponseDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof IpResponseDto
     */
    'ip': string;
    /**
     * Enable ASM monitoring for this IP asset (changes, vulnerabilities, threats)
     * @type {boolean}
     * @memberof IpResponseDto
     */
    'monitorEnabled': boolean;
}
/**
 * 
 * @export
 * @interface IpStatDto
 */
export interface IpStatDto {
    /**
     * IP address
     * @type {string}
     * @memberof IpStatDto
     */
    'ipAddress': string;
    /**
     * Count of services on this IP
     * @type {number}
     * @memberof IpStatDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface JwtResponseDto
 */
export interface JwtResponseDto {
    /**
     * 
     * @type {string}
     * @memberof JwtResponseDto
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof JwtResponseDto
     */
    'tokenType': JwtResponseDtoTokenTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof JwtResponseDto
     */
    'expires': number;
}

export const JwtResponseDtoTokenTypeEnum = {
    Bearer: 'bearer'
} as const;

export type JwtResponseDtoTokenTypeEnum = typeof JwtResponseDtoTokenTypeEnum[keyof typeof JwtResponseDtoTokenTypeEnum];

/**
 * LoginDto
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * email of the user
     * @type {string}
     * @memberof LoginDto
     */
    'email': string;
    /**
     * password of the user
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface MeResponseDto
 */
export interface MeResponseDto {
    /**
     * 
     * @type {Array<MeerUserOrganizationResponseDto>}
     * @memberof MeResponseDto
     */
    'organizations': Array<MeerUserOrganizationResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface MeerUserOrganizationResponseDto
 */
export interface MeerUserOrganizationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MeerUserOrganizationResponseDto
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof MeerUserOrganizationResponseDto
     */
    'joinDate': string;
    /**
     * 
     * @type {string}
     * @memberof MeerUserOrganizationResponseDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof MeerUserOrganizationResponseDto
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface OrganizationBasicResponseDto
 */
export interface OrganizationBasicResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationBasicResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBasicResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBasicResponseDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBasicResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBasicResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface OrganizationResponseDto
 */
export interface OrganizationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponseDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationResponseDto
     */
    'isActive': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationResponseDto
     */
    'organizationUsers': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface PaginatedResponseDto
 */
export interface PaginatedResponseDto {
    /**
     * Array of items in the current page
     * @type {object}
     * @memberof PaginatedResponseDto
     */
    'items': object;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof PaginatedResponseDto
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface PaginatedX509CertificatesResponseDto
 */
export interface PaginatedX509CertificatesResponseDto {
    /**
     * List of X509 certificates
     * @type {Array<X509CertificateResponseDto>}
     * @memberof PaginatedX509CertificatesResponseDto
     */
    'items': Array<X509CertificateResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationMetaDto}
     * @memberof PaginatedX509CertificatesResponseDto
     */
    'meta': PaginationMetaDto;
}
/**
 * 
 * @export
 * @interface PaginationMetaDto
 */
export interface PaginationMetaDto {
    /**
     * Total number of items
     * @type {number}
     * @memberof PaginationMetaDto
     */
    'total': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginationMetaDto
     */
    'page': number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof PaginationMetaDto
     */
    'limit': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginationMetaDto
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @interface PortStatDto
 */
export interface PortStatDto {
    /**
     * Port number
     * @type {number}
     * @memberof PortStatDto
     */
    'port': number;
    /**
     * Count of services on this port
     * @type {number}
     * @memberof PortStatDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ReviewChangeRecordDto
 */
export interface ReviewChangeRecordDto {
    /**
     * Status decision for the change record
     * @type {string}
     * @memberof ReviewChangeRecordDto
     */
    'status': ReviewChangeRecordDtoStatusEnum;
    /**
     * Classification tags for the change record (can be multiple). Note: Cannot combine Unauthorized with authorized types, or TruePositive with FalsePositive.
     * @type {Array<string>}
     * @memberof ReviewChangeRecordDto
     */
    'classification': Array<ReviewChangeRecordDtoClassificationEnum>;
    /**
     * Reason for the status and classification decision
     * @type {string}
     * @memberof ReviewChangeRecordDto
     */
    'reason': string;
    /**
     * Whether to apply changes to the database (only required when classification includes Testing)
     * @type {boolean}
     * @memberof ReviewChangeRecordDto
     */
    'applyChanges'?: boolean;
}

export const ReviewChangeRecordDtoStatusEnum = {
    Open: 'open',
    Closed: 'closed',
    All: 'all'
} as const;

export type ReviewChangeRecordDtoStatusEnum = typeof ReviewChangeRecordDtoStatusEnum[keyof typeof ReviewChangeRecordDtoStatusEnum];
export const ReviewChangeRecordDtoClassificationEnum = {
    Unauthorized: 'unauthorized',
    FalsePositive: 'false-positive',
    TruePositive: 'true-positive',
    Testing: 'testing',
    PreAuthorized: 'pre-authorized',
    PostAuthorized: 'post-authorized',
    EmergencyAuthorized: 'emergency-authorized',
    SysSuperseded: 'sys-superseded'
} as const;

export type ReviewChangeRecordDtoClassificationEnum = typeof ReviewChangeRecordDtoClassificationEnum[keyof typeof ReviewChangeRecordDtoClassificationEnum];

/**
 * 
 * @export
 * @interface SSLCertStatsResponseDto
 */
export interface SSLCertStatsResponseDto {
    /**
     * Distribution of certificates by expiry status
     * @type {Array<ExpiryStatusCountDto>}
     * @memberof SSLCertStatsResponseDto
     */
    'expiryStatus': Array<ExpiryStatusCountDto>;
    /**
     * Top 5 most common certificate authorities
     * @type {Array<CADistributionDto>}
     * @memberof SSLCertStatsResponseDto
     */
    'topCAs': Array<CADistributionDto>;
    /**
     * List of certificates expiring soon
     * @type {Array<ExpiringCertificateDto>}
     * @memberof SSLCertStatsResponseDto
     */
    'expiringSoon': Array<ExpiringCertificateDto>;
    /**
     * Total number of certificates
     * @type {number}
     * @memberof SSLCertStatsResponseDto
     */
    'totalCertificates': number;
    /**
     * Number of distinct domains
     * @type {number}
     * @memberof SSLCertStatsResponseDto
     */
    'distinctDomains': number;
    /**
     * Count of certificates by grade
     * @type {{ [key: string]: number; }}
     * @memberof SSLCertStatsResponseDto
     */
    'grades': { [key: string]: number; };
    /**
     * 
     * @type {SSLCertStatsResponseDtoChartColors}
     * @memberof SSLCertStatsResponseDto
     */
    'chartColors': SSLCertStatsResponseDtoChartColors;
}
/**
 * Colors for charts
 * @export
 * @interface SSLCertStatsResponseDtoChartColors
 */
export interface SSLCertStatsResponseDtoChartColors {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SSLCertStatsResponseDtoChartColors
     */
    'expiry'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof SSLCertStatsResponseDtoChartColors
     */
    'ca'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SSLCertificateChangeDetailsResponseDto
 */
export interface SSLCertificateChangeDetailsResponseDto {
    /**
     * ID of the associated change record
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'changeId': string;
    /**
     * 
     * @type {ChangeRecordBasicResponseDto}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'changeRecord': ChangeRecordBasicResponseDto;
    /**
     * Reference to the domain asset, if applicable.
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'domainId'?: string;
    /**
     * 
     * @type {DomainBasicResponseDto}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'domain'?: DomainBasicResponseDto;
    /**
     * Domain name for the certificate
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'domainName': string;
    /**
     * IP address where the certificate was found
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'ip': string;
    /**
     * Port where the certificate was found
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'port': string;
    /**
     * Previous certificate grade
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'previousGrade'?: string;
    /**
     * New certificate grade
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'newGrade'?: string;
    /**
     * Previous certificate expiry date
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'previousExpiryDate'?: string;
    /**
     * New certificate expiry date
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'newExpiryDate'?: string;
    /**
     * Previous certificate issuer
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'previousIssuer'?: string;
    /**
     * New certificate issuer
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'newIssuer'?: string;
    /**
     * Previous certificate algorithm
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'previousAlgorithm'?: string;
    /**
     * New certificate algorithm
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'newAlgorithm'?: string;
    /**
     * Previous certificate key size
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'previousKeySize'?: string;
    /**
     * New certificate key size
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'newKeySize'?: string;
    /**
     * Previous certificate hash
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'previousCertHash'?: string;
    /**
     * New certificate hash
     * @type {string}
     * @memberof SSLCertificateChangeDetailsResponseDto
     */
    'newCertHash'?: string;
}
/**
 * 
 * @export
 * @interface SSLCertificateResponseDto
 */
export interface SSLCertificateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'orgId': string;
    /**
     * 
     * @type {OrganizationBasicResponseDto}
     * @memberof SSLCertificateResponseDto
     */
    'organization': OrganizationBasicResponseDto;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'domainId': string;
    /**
     * 
     * @type {DomainBasicResponseDto}
     * @memberof SSLCertificateResponseDto
     */
    'domainEntity': DomainBasicResponseDto;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'ip': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'port': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'grade': string;
    /**
     * 
     * @type {object}
     * @memberof SSLCertificateResponseDto
     */
    'expiry_date': object;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'issuer': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'algorithm': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'key_size': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'cert_hash': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'notes': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SSLCertificateResponseDto
     */
    'tags': Array<string>;
    /**
     * Enable ASM monitoring for this SSL certificate (changes, vulnerabilities, expiration)
     * @type {boolean}
     * @memberof SSLCertificateResponseDto
     */
    'monitorEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SSLCertificateResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ServiceStatDto
 */
export interface ServiceStatDto {
    /**
     * Service name
     * @type {string}
     * @memberof ServiceStatDto
     */
    'serviceName': string;
    /**
     * Count of this service type
     * @type {number}
     * @memberof ServiceStatDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface X509CertificateChangeDetailsResponseDto
 */
export interface X509CertificateChangeDetailsResponseDto {
    /**
     * ID of the associated change record
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'changeRecordId': string;
    /**
     * IP address where the certificate was found
     * @type {object}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'hostIp': object | null;
    /**
     * Server Name Indication (SNI) for the certificate
     * @type {object}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'hostSni': object | null;
    /**
     * Port where the certificate was found
     * @type {object}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'port': object | null;
    /**
     * ID of the certificate chain
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'chainId': string;
    /**
     * Index of the certificate in the chain
     * @type {number}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'certIndex': number;
    /**
     * Previous certificate subject DN
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousSubjectDn': string;
    /**
     * New certificate subject DN
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newSubjectDn': string;
    /**
     * Previous certificate issuer DN
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousIssuerDn': string;
    /**
     * New certificate issuer DN
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newIssuerDn': string;
    /**
     * Previous certificate serial number
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousSerialNumber': string;
    /**
     * New certificate serial number
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newSerialNumber': string;
    /**
     * Previous certificate validity start date
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousNotBefore': string;
    /**
     * New certificate validity start date
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newNotBefore': string;
    /**
     * Previous certificate validity end date
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousNotAfter': string;
    /**
     * New certificate validity end date
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newNotAfter': string;
    /**
     * Previous certificate PEM hash
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousPemData': string;
    /**
     * New certificate PEM hash
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newPemData': string;
    /**
     * Previous certificate key algorithm
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousKeyAlgorithm': string;
    /**
     * New certificate key algorithm
     * @type {string}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newKeyAlgorithm': string;
    /**
     * Previous certificate key size
     * @type {number}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousKeySize': number;
    /**
     * New certificate key size
     * @type {number}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newKeySize': number;
    /**
     * Previous certificate chain data
     * @type {{ [key: string]: any; }}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'previousCertificateChain': { [key: string]: any; };
    /**
     * New certificate chain data
     * @type {{ [key: string]: any; }}
     * @memberof X509CertificateChangeDetailsResponseDto
     */
    'newCertificateChain': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface X509CertificateResponseDto
 */
export interface X509CertificateResponseDto {
    /**
     * Unique identifier for the certificate
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'id': string;
    /**
     * Organization ID that owns this certificate
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'orgId': string;
    /**
     * IP address of the host where this certificate was obtained
     * @type {object}
     * @memberof X509CertificateResponseDto
     */
    'hostIp': object | null;
    /**
     * Server Name Indication (SNI) used when connecting to the host
     * @type {object}
     * @memberof X509CertificateResponseDto
     */
    'hostSni': object | null;
    /**
     * Port number where the certificate was observed
     * @type {object}
     * @memberof X509CertificateResponseDto
     */
    'port': object | null;
    /**
     * Date when this certificate was first observed
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'firstSeen': string;
    /**
     * Date when this certificate was most recently observed
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'lastSeen': string;
    /**
     * Tags for categorizing certificates
     * @type {Array<string>}
     * @memberof X509CertificateResponseDto
     */
    'tags': Array<string>;
    /**
     * Whether this certificate should be monitored for changes
     * @type {boolean}
     * @memberof X509CertificateResponseDto
     */
    'monitorEnabled': boolean;
    /**
     * User or system that last updated this certificate record
     * @type {object}
     * @memberof X509CertificateResponseDto
     */
    'updatedBy': object | null;
    /**
     * Certificate subject (who it was issued to)
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'subjectDn': string;
    /**
     * Certificate issuer (who issued it)
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'issuerDn': string;
    /**
     * Certificate serial number
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'serialNumber': string;
    /**
     * Certificate validity start date
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'notBefore': string;
    /**
     * Certificate validity end date
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'notAfter': string;
    /**
     * PEM-encoded certificate data
     * @type {object}
     * @memberof X509CertificateResponseDto
     */
    'pemData': object | null;
    /**
     * Public key algorithm
     * @type {object}
     * @memberof X509CertificateResponseDto
     */
    'keyAlgorithm': object | null;
    /**
     * Public key size in bits
     * @type {object}
     * @memberof X509CertificateResponseDto
     */
    'keySize': object | null;
    /**
     * Certificate chain with intermediate and root certificates
     * @type {Array<X509CertificateResponseDtoCertificateChainInner>}
     * @memberof X509CertificateResponseDto
     */
    'certificateChain': Array<X509CertificateResponseDtoCertificateChainInner> | null;
    /**
     * Date when the certificate record was created
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'createdAt': string;
    /**
     * Date when the certificate record was last updated
     * @type {string}
     * @memberof X509CertificateResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface X509CertificateResponseDtoCertificateChainInner
 */
export interface X509CertificateResponseDtoCertificateChainInner {
    /**
     * 
     * @type {string}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'subjectDn'?: string;
    /**
     * 
     * @type {string}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'issuerDn'?: string;
    /**
     * 
     * @type {string}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'serialNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'notBefore'?: string;
    /**
     * 
     * @type {string}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'notAfter'?: string;
    /**
     * 
     * @type {string}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'pemData'?: string;
    /**
     * 
     * @type {string}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'keyAlgorithm'?: string;
    /**
     * 
     * @type {number}
     * @memberof X509CertificateResponseDtoCertificateChainInner
     */
    'keySize'?: number;
}

/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {CreateCidrDto} createCidrDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateCidr: async (orgId: string, createCidrDto: CreateCidrDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerCreateCidr', 'orgId', orgId)
            // verify required parameter 'createCidrDto' is not null or undefined
            assertParamExists('assetsControllerCreateCidr', 'createCidrDto', createCidrDto)
            const localVarPath = `/msc/organizations/{orgId}/assets/cidr`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCidrDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateDomainDto} createDomainDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateDomain: async (orgId: string, createDomainDto: CreateDomainDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerCreateDomain', 'orgId', orgId)
            // verify required parameter 'createDomainDto' is not null or undefined
            assertParamExists('assetsControllerCreateDomain', 'createDomainDto', createDomainDto)
            const localVarPath = `/msc/organizations/{orgId}/assets/domain`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDomainDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateIpDto} createIpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateIp: async (orgId: string, createIpDto: CreateIpDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerCreateIp', 'orgId', orgId)
            // verify required parameter 'createIpDto' is not null or undefined
            assertParamExists('assetsControllerCreateIp', 'createIpDto', createIpDto)
            const localVarPath = `/msc/organizations/{orgId}/assets/ip`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIpDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllCidr: async (orgId: string, search?: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerFindAllCidr', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/assets/cidr`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllDnsRecords: async (orgId: string, search?: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerFindAllDnsRecords', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/assets/dns-records`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllDomain: async (orgId: string, search?: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerFindAllDomain', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/assets/domain`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllIp: async (orgId: string, search?: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerFindAllIp', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/assets/ip`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllX509Certificates: async (orgId: string, search?: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerFindAllX509Certificates', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/assets/x509-certificates`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the X.509 certificate data for a specific SSL certificate
         * @summary Get X.509 certificate details
         * @param {string} orgId Organization ID
         * @param {string} id SSL Certificate ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerGetX509Certificate: async (orgId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assetsControllerGetX509Certificate', 'orgId', orgId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetsControllerGetX509Certificate', 'id', id)
            const localVarPath = `/msc/organizations/{orgId}/assets/ssl-certificates/{id}/x509`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {CreateCidrDto} createCidrDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerCreateCidr(orgId: string, createCidrDto: CreateCidrDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCidrDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerCreateCidr(orgId, createCidrDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerCreateCidr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateDomainDto} createDomainDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerCreateDomain(orgId: string, createDomainDto: CreateDomainDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDomainDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerCreateDomain(orgId, createDomainDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerCreateDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateIpDto} createIpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerCreateIp(orgId: string, createIpDto: CreateIpDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateIpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerCreateIp(orgId, createIpDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerCreateIp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindAllCidr(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsControllerFindAllCidr200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindAllCidr(orgId, search, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerFindAllCidr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindAllDnsRecords(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsControllerFindAllDnsRecords200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindAllDnsRecords(orgId, search, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerFindAllDnsRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindAllDomain(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsControllerFindAllDomain200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindAllDomain(orgId, search, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerFindAllDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindAllIp(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsControllerFindAllIp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindAllIp(orgId, search, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerFindAllIp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindAllX509Certificates(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetsControllerFindAllX509Certificates200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindAllX509Certificates(orgId, search, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerFindAllX509Certificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the X.509 certificate data for a specific SSL certificate
         * @summary Get X.509 certificate details
         * @param {string} orgId Organization ID
         * @param {string} id SSL Certificate ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerGetX509Certificate(orgId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerGetX509Certificate(orgId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.assetsControllerGetX509Certificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {CreateCidrDto} createCidrDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateCidr(orgId: string, createCidrDto: CreateCidrDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateCidrDto> {
            return localVarFp.assetsControllerCreateCidr(orgId, createCidrDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateDomainDto} createDomainDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateDomain(orgId: string, createDomainDto: CreateDomainDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateDomainDto> {
            return localVarFp.assetsControllerCreateDomain(orgId, createDomainDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateIpDto} createIpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateIp(orgId: string, createIpDto: CreateIpDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateIpDto> {
            return localVarFp.assetsControllerCreateIp(orgId, createIpDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllCidr(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<AssetsControllerFindAllCidr200Response> {
            return localVarFp.assetsControllerFindAllCidr(orgId, search, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllDnsRecords(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<AssetsControllerFindAllDnsRecords200Response> {
            return localVarFp.assetsControllerFindAllDnsRecords(orgId, search, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllDomain(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<AssetsControllerFindAllDomain200Response> {
            return localVarFp.assetsControllerFindAllDomain(orgId, search, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllIp(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<AssetsControllerFindAllIp200Response> {
            return localVarFp.assetsControllerFindAllIp(orgId, search, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAllX509Certificates(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<AssetsControllerFindAllX509Certificates200Response> {
            return localVarFp.assetsControllerFindAllX509Certificates(orgId, search, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the X.509 certificate data for a specific SSL certificate
         * @summary Get X.509 certificate details
         * @param {string} orgId Organization ID
         * @param {string} id SSL Certificate ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerGetX509Certificate(orgId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<X509CertificateResponseDto> {
            return localVarFp.assetsControllerGetX509Certificate(orgId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
    /**
     * 
     * @param {string} orgId 
     * @param {CreateCidrDto} createCidrDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerCreateCidr(orgId: string, createCidrDto: CreateCidrDto, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerCreateCidr(orgId, createCidrDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {CreateDomainDto} createDomainDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerCreateDomain(orgId: string, createDomainDto: CreateDomainDto, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerCreateDomain(orgId, createDomainDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {CreateIpDto} createIpDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerCreateIp(orgId: string, createIpDto: CreateIpDto, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerCreateIp(orgId, createIpDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerFindAllCidr(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerFindAllCidr(orgId, search, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerFindAllDnsRecords(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerFindAllDnsRecords(orgId, search, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerFindAllDomain(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerFindAllDomain(orgId, search, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerFindAllIp(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerFindAllIp(orgId, search, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgId 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerFindAllX509Certificates(orgId: string, search?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerFindAllX509Certificates(orgId, search, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the X.509 certificate data for a specific SSL certificate
     * @summary Get X.509 certificate details
     * @param {string} orgId Organization ID
     * @param {string} id SSL Certificate ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetsControllerGetX509Certificate(orgId: string, id: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetsControllerGetX509Certificate(orgId, id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChangeRecordsApi - axios parameter creator
 * @export
 */
export const ChangeRecordsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all change records for an organization with filtering, sorting, and pagination
         * @param {string} orgId Organization ID
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 10)
         * @param {string} [sort] Field to sort by (default: detectionTime)
         * @param {ChangeRecordsControllerFindAllOrderEnum} [order] Sort order (default: DESC)
         * @param {ChangeRecordsControllerFindAllAssetTypeEnum} [assetType] Filter by asset type (e.g., DNS, Certificate)
         * @param {ChangeRecordsControllerFindAllChangeTypeEnum} [changeType] Filter by change type (e.g., New, Modified, Deleted)
         * @param {ChangeRecordsControllerFindAllStatusEnum} [status] Filter by status (Open or Closed)
         * @param {Array<ChangeRecordsControllerFindAllClassificationEnum>} [classification] Filter by classification tags (can specify multiple)
         * @param {string} [search] Search term for assetIdentifier, changeTitle, or changeSummary
         * @param {string} [startDate] Filter by detection time start date
         * @param {string} [endDate] Filter by detection time end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerFindAll: async (orgId: string, page?: number, limit?: number, sort?: string, order?: ChangeRecordsControllerFindAllOrderEnum, assetType?: ChangeRecordsControllerFindAllAssetTypeEnum, changeType?: ChangeRecordsControllerFindAllChangeTypeEnum, status?: ChangeRecordsControllerFindAllStatusEnum, classification?: Array<ChangeRecordsControllerFindAllClassificationEnum>, search?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('changeRecordsControllerFindAll', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/change-records`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (assetType !== undefined) {
                localVarQueryParameter['assetType'] = assetType;
            }

            if (changeType !== undefined) {
                localVarQueryParameter['changeType'] = changeType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (classification) {
                localVarQueryParameter['classification'] = classification;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a change record by ID for an organization
         * @param {string} orgId Organization ID
         * @param {string} id Change record ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerFindOne: async (orgId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('changeRecordsControllerFindOne', 'orgId', orgId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeRecordsControllerFindOne', 'id', id)
            const localVarPath = `/msc/organizations/{orgId}/change-records/{id}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns chronological timeline of changes for an asset identified by its unique identifier
         * @summary Get timeline of all changes for a specific asset
         * @param {string} orgId Organization ID
         * @param {string} assetIdentifier Asset identifier (e.g., domain name for DNS, IP:port for ports)
         * @param {number} [limit] Maximum number of changes to return
         * @param {string} [assetType] Filter by specific asset type (e.g., DNS, Certificate, Port)
         * @param {any} [assetTimelineQueryDto] Asset timeline query parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerGetAssetTimeline: async (orgId: string, assetIdentifier: string, limit?: number, assetType?: string, assetTimelineQueryDto?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('changeRecordsControllerGetAssetTimeline', 'orgId', orgId)
            // verify required parameter 'assetIdentifier' is not null or undefined
            assertParamExists('changeRecordsControllerGetAssetTimeline', 'assetIdentifier', assetIdentifier)
            const localVarPath = `/msc/organizations/{orgId}/change-records/actions/timeline/{assetIdentifier}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"assetIdentifier"}}`, encodeURIComponent(String(assetIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (assetType !== undefined) {
                localVarQueryParameter['assetType'] = assetType;
            }

            if (assetTimelineQueryDto !== undefined) {
                for (const [key, value] of Object.entries(assetTimelineQueryDto)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the change record with asset-type-specific details from the appropriate detail table
         * @summary Get detailed change information including asset-specific details
         * @param {string} orgId Organization ID
         * @param {string} id Change record ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerGetChangeDetails: async (orgId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('changeRecordsControllerGetChangeDetails', 'orgId', orgId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeRecordsControllerGetChangeDetails', 'id', id)
            const localVarPath = `/msc/organizations/{orgId}/change-records/{id}/details`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status and classification of a change record. Changes are automatically applied to the database if status is Closed and classification includes authorized types. For Testing classification, user must specify whether to apply changes.
         * @summary Review a change record
         * @param {string} assetChangeId Change record ID
         * @param {string} orgId Organization ID
         * @param {ReviewChangeRecordDto} reviewChangeRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerReviewChangeRecord: async (assetChangeId: string, orgId: string, reviewChangeRecordDto: ReviewChangeRecordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetChangeId' is not null or undefined
            assertParamExists('changeRecordsControllerReviewChangeRecord', 'assetChangeId', assetChangeId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('changeRecordsControllerReviewChangeRecord', 'orgId', orgId)
            // verify required parameter 'reviewChangeRecordDto' is not null or undefined
            assertParamExists('changeRecordsControllerReviewChangeRecord', 'reviewChangeRecordDto', reviewChangeRecordDto)
            const localVarPath = `/msc/organizations/{orgId}/change-records/{assetChangeId}/actions/review`
                .replace(`{${"assetChangeId"}}`, encodeURIComponent(String(assetChangeId)))
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewChangeRecordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangeRecordsApi - functional programming interface
 * @export
 */
export const ChangeRecordsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChangeRecordsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all change records for an organization with filtering, sorting, and pagination
         * @param {string} orgId Organization ID
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 10)
         * @param {string} [sort] Field to sort by (default: detectionTime)
         * @param {ChangeRecordsControllerFindAllOrderEnum} [order] Sort order (default: DESC)
         * @param {ChangeRecordsControllerFindAllAssetTypeEnum} [assetType] Filter by asset type (e.g., DNS, Certificate)
         * @param {ChangeRecordsControllerFindAllChangeTypeEnum} [changeType] Filter by change type (e.g., New, Modified, Deleted)
         * @param {ChangeRecordsControllerFindAllStatusEnum} [status] Filter by status (Open or Closed)
         * @param {Array<ChangeRecordsControllerFindAllClassificationEnum>} [classification] Filter by classification tags (can specify multiple)
         * @param {string} [search] Search term for assetIdentifier, changeTitle, or changeSummary
         * @param {string} [startDate] Filter by detection time start date
         * @param {string} [endDate] Filter by detection time end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeRecordsControllerFindAll(orgId: string, page?: number, limit?: number, sort?: string, order?: ChangeRecordsControllerFindAllOrderEnum, assetType?: ChangeRecordsControllerFindAllAssetTypeEnum, changeType?: ChangeRecordsControllerFindAllChangeTypeEnum, status?: ChangeRecordsControllerFindAllStatusEnum, classification?: Array<ChangeRecordsControllerFindAllClassificationEnum>, search?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRecordsControllerFindAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeRecordsControllerFindAll(orgId, page, limit, sort, order, assetType, changeType, status, classification, search, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRecordsApi.changeRecordsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a change record by ID for an organization
         * @param {string} orgId Organization ID
         * @param {string} id Change record ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeRecordsControllerFindOne(orgId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRecordResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeRecordsControllerFindOne(orgId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRecordsApi.changeRecordsControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns chronological timeline of changes for an asset identified by its unique identifier
         * @summary Get timeline of all changes for a specific asset
         * @param {string} orgId Organization ID
         * @param {string} assetIdentifier Asset identifier (e.g., domain name for DNS, IP:port for ports)
         * @param {number} [limit] Maximum number of changes to return
         * @param {string} [assetType] Filter by specific asset type (e.g., DNS, Certificate, Port)
         * @param {any} [assetTimelineQueryDto] Asset timeline query parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeRecordsControllerGetAssetTimeline(orgId: string, assetIdentifier: string, limit?: number, assetType?: string, assetTimelineQueryDto?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChangeRecordResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeRecordsControllerGetAssetTimeline(orgId, assetIdentifier, limit, assetType, assetTimelineQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRecordsApi.changeRecordsControllerGetAssetTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the change record with asset-type-specific details from the appropriate detail table
         * @summary Get detailed change information including asset-specific details
         * @param {string} orgId Organization ID
         * @param {string} id Change record ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeRecordsControllerGetChangeDetails(orgId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRecordsControllerGetChangeDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeRecordsControllerGetChangeDetails(orgId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRecordsApi.changeRecordsControllerGetChangeDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status and classification of a change record. Changes are automatically applied to the database if status is Closed and classification includes authorized types. For Testing classification, user must specify whether to apply changes.
         * @summary Review a change record
         * @param {string} assetChangeId Change record ID
         * @param {string} orgId Organization ID
         * @param {ReviewChangeRecordDto} reviewChangeRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeRecordsControllerReviewChangeRecord(assetChangeId: string, orgId: string, reviewChangeRecordDto: ReviewChangeRecordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRecordResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeRecordsControllerReviewChangeRecord(assetChangeId, orgId, reviewChangeRecordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRecordsApi.changeRecordsControllerReviewChangeRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChangeRecordsApi - factory interface
 * @export
 */
export const ChangeRecordsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChangeRecordsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all change records for an organization with filtering, sorting, and pagination
         * @param {string} orgId Organization ID
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 10)
         * @param {string} [sort] Field to sort by (default: detectionTime)
         * @param {ChangeRecordsControllerFindAllOrderEnum} [order] Sort order (default: DESC)
         * @param {ChangeRecordsControllerFindAllAssetTypeEnum} [assetType] Filter by asset type (e.g., DNS, Certificate)
         * @param {ChangeRecordsControllerFindAllChangeTypeEnum} [changeType] Filter by change type (e.g., New, Modified, Deleted)
         * @param {ChangeRecordsControllerFindAllStatusEnum} [status] Filter by status (Open or Closed)
         * @param {Array<ChangeRecordsControllerFindAllClassificationEnum>} [classification] Filter by classification tags (can specify multiple)
         * @param {string} [search] Search term for assetIdentifier, changeTitle, or changeSummary
         * @param {string} [startDate] Filter by detection time start date
         * @param {string} [endDate] Filter by detection time end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerFindAll(orgId: string, page?: number, limit?: number, sort?: string, order?: ChangeRecordsControllerFindAllOrderEnum, assetType?: ChangeRecordsControllerFindAllAssetTypeEnum, changeType?: ChangeRecordsControllerFindAllChangeTypeEnum, status?: ChangeRecordsControllerFindAllStatusEnum, classification?: Array<ChangeRecordsControllerFindAllClassificationEnum>, search?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRecordsControllerFindAll200Response> {
            return localVarFp.changeRecordsControllerFindAll(orgId, page, limit, sort, order, assetType, changeType, status, classification, search, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a change record by ID for an organization
         * @param {string} orgId Organization ID
         * @param {string} id Change record ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerFindOne(orgId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRecordResponseDto> {
            return localVarFp.changeRecordsControllerFindOne(orgId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns chronological timeline of changes for an asset identified by its unique identifier
         * @summary Get timeline of all changes for a specific asset
         * @param {string} orgId Organization ID
         * @param {string} assetIdentifier Asset identifier (e.g., domain name for DNS, IP:port for ports)
         * @param {number} [limit] Maximum number of changes to return
         * @param {string} [assetType] Filter by specific asset type (e.g., DNS, Certificate, Port)
         * @param {any} [assetTimelineQueryDto] Asset timeline query parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerGetAssetTimeline(orgId: string, assetIdentifier: string, limit?: number, assetType?: string, assetTimelineQueryDto?: any, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChangeRecordResponseDto>> {
            return localVarFp.changeRecordsControllerGetAssetTimeline(orgId, assetIdentifier, limit, assetType, assetTimelineQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the change record with asset-type-specific details from the appropriate detail table
         * @summary Get detailed change information including asset-specific details
         * @param {string} orgId Organization ID
         * @param {string} id Change record ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerGetChangeDetails(orgId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRecordsControllerGetChangeDetails200Response> {
            return localVarFp.changeRecordsControllerGetChangeDetails(orgId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status and classification of a change record. Changes are automatically applied to the database if status is Closed and classification includes authorized types. For Testing classification, user must specify whether to apply changes.
         * @summary Review a change record
         * @param {string} assetChangeId Change record ID
         * @param {string} orgId Organization ID
         * @param {ReviewChangeRecordDto} reviewChangeRecordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeRecordsControllerReviewChangeRecord(assetChangeId: string, orgId: string, reviewChangeRecordDto: ReviewChangeRecordDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeRecordResponseDto> {
            return localVarFp.changeRecordsControllerReviewChangeRecord(assetChangeId, orgId, reviewChangeRecordDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChangeRecordsApi - object-oriented interface
 * @export
 * @class ChangeRecordsApi
 * @extends {BaseAPI}
 */
export class ChangeRecordsApi extends BaseAPI {
    /**
     * 
     * @summary Get all change records for an organization with filtering, sorting, and pagination
     * @param {string} orgId Organization ID
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Items per page (default: 10)
     * @param {string} [sort] Field to sort by (default: detectionTime)
     * @param {ChangeRecordsControllerFindAllOrderEnum} [order] Sort order (default: DESC)
     * @param {ChangeRecordsControllerFindAllAssetTypeEnum} [assetType] Filter by asset type (e.g., DNS, Certificate)
     * @param {ChangeRecordsControllerFindAllChangeTypeEnum} [changeType] Filter by change type (e.g., New, Modified, Deleted)
     * @param {ChangeRecordsControllerFindAllStatusEnum} [status] Filter by status (Open or Closed)
     * @param {Array<ChangeRecordsControllerFindAllClassificationEnum>} [classification] Filter by classification tags (can specify multiple)
     * @param {string} [search] Search term for assetIdentifier, changeTitle, or changeSummary
     * @param {string} [startDate] Filter by detection time start date
     * @param {string} [endDate] Filter by detection time end date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRecordsApi
     */
    public changeRecordsControllerFindAll(orgId: string, page?: number, limit?: number, sort?: string, order?: ChangeRecordsControllerFindAllOrderEnum, assetType?: ChangeRecordsControllerFindAllAssetTypeEnum, changeType?: ChangeRecordsControllerFindAllChangeTypeEnum, status?: ChangeRecordsControllerFindAllStatusEnum, classification?: Array<ChangeRecordsControllerFindAllClassificationEnum>, search?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return ChangeRecordsApiFp(this.configuration).changeRecordsControllerFindAll(orgId, page, limit, sort, order, assetType, changeType, status, classification, search, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a change record by ID for an organization
     * @param {string} orgId Organization ID
     * @param {string} id Change record ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRecordsApi
     */
    public changeRecordsControllerFindOne(orgId: string, id: string, options?: RawAxiosRequestConfig) {
        return ChangeRecordsApiFp(this.configuration).changeRecordsControllerFindOne(orgId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns chronological timeline of changes for an asset identified by its unique identifier
     * @summary Get timeline of all changes for a specific asset
     * @param {string} orgId Organization ID
     * @param {string} assetIdentifier Asset identifier (e.g., domain name for DNS, IP:port for ports)
     * @param {number} [limit] Maximum number of changes to return
     * @param {string} [assetType] Filter by specific asset type (e.g., DNS, Certificate, Port)
     * @param {any} [assetTimelineQueryDto] Asset timeline query parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRecordsApi
     */
    public changeRecordsControllerGetAssetTimeline(orgId: string, assetIdentifier: string, limit?: number, assetType?: string, assetTimelineQueryDto?: any, options?: RawAxiosRequestConfig) {
        return ChangeRecordsApiFp(this.configuration).changeRecordsControllerGetAssetTimeline(orgId, assetIdentifier, limit, assetType, assetTimelineQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the change record with asset-type-specific details from the appropriate detail table
     * @summary Get detailed change information including asset-specific details
     * @param {string} orgId Organization ID
     * @param {string} id Change record ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRecordsApi
     */
    public changeRecordsControllerGetChangeDetails(orgId: string, id: string, options?: RawAxiosRequestConfig) {
        return ChangeRecordsApiFp(this.configuration).changeRecordsControllerGetChangeDetails(orgId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status and classification of a change record. Changes are automatically applied to the database if status is Closed and classification includes authorized types. For Testing classification, user must specify whether to apply changes.
     * @summary Review a change record
     * @param {string} assetChangeId Change record ID
     * @param {string} orgId Organization ID
     * @param {ReviewChangeRecordDto} reviewChangeRecordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRecordsApi
     */
    public changeRecordsControllerReviewChangeRecord(assetChangeId: string, orgId: string, reviewChangeRecordDto: ReviewChangeRecordDto, options?: RawAxiosRequestConfig) {
        return ChangeRecordsApiFp(this.configuration).changeRecordsControllerReviewChangeRecord(assetChangeId, orgId, reviewChangeRecordDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ChangeRecordsControllerFindAllOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ChangeRecordsControllerFindAllOrderEnum = typeof ChangeRecordsControllerFindAllOrderEnum[keyof typeof ChangeRecordsControllerFindAllOrderEnum];
/**
 * @export
 */
export const ChangeRecordsControllerFindAllAssetTypeEnum = {
    Dns: 'dns',
    SslCertificate: 'ssl-certificate',
    X509Certificate: 'x509-certificate',
    IpAddress: 'ip-address',
    InternetService: 'internet-service'
} as const;
export type ChangeRecordsControllerFindAllAssetTypeEnum = typeof ChangeRecordsControllerFindAllAssetTypeEnum[keyof typeof ChangeRecordsControllerFindAllAssetTypeEnum];
/**
 * @export
 */
export const ChangeRecordsControllerFindAllChangeTypeEnum = {
    Created: 'created',
    Modified: 'modified'
} as const;
export type ChangeRecordsControllerFindAllChangeTypeEnum = typeof ChangeRecordsControllerFindAllChangeTypeEnum[keyof typeof ChangeRecordsControllerFindAllChangeTypeEnum];
/**
 * @export
 */
export const ChangeRecordsControllerFindAllStatusEnum = {
    Open: 'open',
    Closed: 'closed',
    All: 'all'
} as const;
export type ChangeRecordsControllerFindAllStatusEnum = typeof ChangeRecordsControllerFindAllStatusEnum[keyof typeof ChangeRecordsControllerFindAllStatusEnum];
/**
 * @export
 */
export const ChangeRecordsControllerFindAllClassificationEnum = {
    Unauthorized: 'unauthorized',
    FalsePositive: 'false-positive',
    TruePositive: 'true-positive',
    Testing: 'testing',
    PreAuthorized: 'pre-authorized',
    PostAuthorized: 'post-authorized',
    EmergencyAuthorized: 'emergency-authorized',
    SysSuperseded: 'sys-superseded'
} as const;
export type ChangeRecordsControllerFindAllClassificationEnum = typeof ChangeRecordsControllerFindAllClassificationEnum[keyof typeof ChangeRecordsControllerFindAllClassificationEnum];


/**
 * DiscoveriesApi - axios parameter creator
 * @export
 */
export const DiscoveriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find all internet services
         * @param {string} orgId 
         * @param {string} [search] General search term for any field
         * @param {string} [service] Filter by service name
         * @param {number} [port] Filter by port number
         * @param {string} [ip] Filter by IP address
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discoveriesControllerFindAllInternetServices: async (orgId: string, search?: string, service?: string, port?: number, ip?: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('discoveriesControllerFindAllInternetServices', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/discoveries/internet-services`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (service !== undefined) {
                localVarQueryParameter['service'] = service;
            }

            if (port !== undefined) {
                localVarQueryParameter['port'] = port;
            }

            if (ip !== undefined) {
                localVarQueryParameter['ip'] = ip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns statistics about internet services including ports, services, and IPs
         * @summary Get internet service statistics
         * @param {string} orgId Organization ID
         * @param {number} [limit] Maximum number of items to return in each category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discoveriesControllerGetInternetServiceStats: async (orgId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('discoveriesControllerGetInternetServiceStats', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/discoveries/internet-services/stats`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscoveriesApi - functional programming interface
 * @export
 */
export const DiscoveriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscoveriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Find all internet services
         * @param {string} orgId 
         * @param {string} [search] General search term for any field
         * @param {string} [service] Filter by service name
         * @param {number} [port] Filter by port number
         * @param {string} [ip] Filter by IP address
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discoveriesControllerFindAllInternetServices(orgId: string, search?: string, service?: string, port?: number, ip?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscoveriesControllerFindAllInternetServices200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discoveriesControllerFindAllInternetServices(orgId, search, service, port, ip, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscoveriesApi.discoveriesControllerFindAllInternetServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns statistics about internet services including ports, services, and IPs
         * @summary Get internet service statistics
         * @param {string} orgId Organization ID
         * @param {number} [limit] Maximum number of items to return in each category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discoveriesControllerGetInternetServiceStats(orgId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternetServiceStatsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discoveriesControllerGetInternetServiceStats(orgId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscoveriesApi.discoveriesControllerGetInternetServiceStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscoveriesApi - factory interface
 * @export
 */
export const DiscoveriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscoveriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Find all internet services
         * @param {string} orgId 
         * @param {string} [search] General search term for any field
         * @param {string} [service] Filter by service name
         * @param {number} [port] Filter by port number
         * @param {string} [ip] Filter by IP address
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discoveriesControllerFindAllInternetServices(orgId: string, search?: string, service?: string, port?: number, ip?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<DiscoveriesControllerFindAllInternetServices200Response> {
            return localVarFp.discoveriesControllerFindAllInternetServices(orgId, search, service, port, ip, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns statistics about internet services including ports, services, and IPs
         * @summary Get internet service statistics
         * @param {string} orgId Organization ID
         * @param {number} [limit] Maximum number of items to return in each category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discoveriesControllerGetInternetServiceStats(orgId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<InternetServiceStatsResponseDto> {
            return localVarFp.discoveriesControllerGetInternetServiceStats(orgId, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiscoveriesApi - object-oriented interface
 * @export
 * @class DiscoveriesApi
 * @extends {BaseAPI}
 */
export class DiscoveriesApi extends BaseAPI {
    /**
     * 
     * @summary Find all internet services
     * @param {string} orgId 
     * @param {string} [search] General search term for any field
     * @param {string} [service] Filter by service name
     * @param {number} [port] Filter by port number
     * @param {string} [ip] Filter by IP address
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscoveriesApi
     */
    public discoveriesControllerFindAllInternetServices(orgId: string, search?: string, service?: string, port?: number, ip?: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return DiscoveriesApiFp(this.configuration).discoveriesControllerFindAllInternetServices(orgId, search, service, port, ip, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns statistics about internet services including ports, services, and IPs
     * @summary Get internet service statistics
     * @param {string} orgId Organization ID
     * @param {number} [limit] Maximum number of items to return in each category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscoveriesApi
     */
    public discoveriesControllerGetInternetServiceStats(orgId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return DiscoveriesApiFp(this.configuration).discoveriesControllerGetInternetServiceStats(orgId, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HelloApi - axios parameter creator
 * @export
 */
export const HelloApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloControllerGetHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/msc/hello/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HelloApi - functional programming interface
 * @export
 */
export const HelloApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HelloApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async helloControllerGetHealth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.helloControllerGetHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelloApi.helloControllerGetHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HelloApi - factory interface
 * @export
 */
export const HelloApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HelloApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloControllerGetHealth(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.helloControllerGetHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HelloApi - object-oriented interface
 * @export
 * @class HelloApi
 * @extends {BaseAPI}
 */
export class HelloApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelloApi
     */
    public helloControllerGetHealth(options?: RawAxiosRequestConfig) {
        return HelloApiFp(this.configuration).helloControllerGetHealth(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meControllerLogin: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('meControllerLogin', 'loginDto', loginDto)
            const localVarPath = `/msc/me/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meControllerMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/msc/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JwtResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meControllerLogin(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.meControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meControllerMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meControllerMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.meControllerMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig): AxiosPromise<JwtResponseDto> {
            return localVarFp.meControllerLogin(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meControllerMe(options?: RawAxiosRequestConfig): AxiosPromise<MeResponseDto> {
            return localVarFp.meControllerMe(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public meControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).meControllerLogin(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public meControllerMe(options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).meControllerMe(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationConfigurationApi - axios parameter creator
 * @export
 */
export const OrganizationConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all configuration values for an organization. Sensitive values are masked for security.
         * @summary Get all organization configurations
         * @param {string} orgId Organization ID (UUID format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerGetAllConfigurations: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('configurationControllerGetAllConfigurations', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/configurations`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specific configuration value for an organization. Use the safe query parameter to get a redacted version of sensitive configurations.
         * @summary Get a specific configuration for an organization
         * @param {string} orgId Organization UUID
         * @param {ConfigurationControllerGetConfigurationConfigKeyEnum} configKey Configuration key
         * @param {boolean} [safe] Return safe (redacted) version of sensitive configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerGetConfiguration: async (orgId: string, configKey: ConfigurationControllerGetConfigurationConfigKeyEnum, safe?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('configurationControllerGetConfiguration', 'orgId', orgId)
            // verify required parameter 'configKey' is not null or undefined
            assertParamExists('configurationControllerGetConfiguration', 'configKey', configKey)
            const localVarPath = `/msc/organizations/{orgId}/configurations/{configKey}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"configKey"}}`, encodeURIComponent(String(configKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (safe !== undefined) {
                localVarQueryParameter['safe'] = safe;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set multiple configuration values for an organization in a single request
         * @summary Set multiple organization configurations
         * @param {string} orgId Organization ID (UUID format)
         * @param {BatchConfigurationDto} batchConfigurationDto Array of configurations to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerSetBatchConfigurations: async (orgId: string, batchConfigurationDto: BatchConfigurationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('configurationControllerSetBatchConfigurations', 'orgId', orgId)
            // verify required parameter 'batchConfigurationDto' is not null or undefined
            assertParamExists('configurationControllerSetBatchConfigurations', 'batchConfigurationDto', batchConfigurationDto)
            const localVarPath = `/msc/organizations/{orgId}/configurations`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or update a configuration value for an organization.
         * @summary Set a configuration for an organization
         * @param {string} orgId Organization UUID
         * @param {ConfigurationControllerSetConfigurationConfigKeyEnum} configKey Configuration key
         * @param {ConfigurationControllerSetConfigurationRequest} configurationControllerSetConfigurationRequest Configuration value to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerSetConfiguration: async (orgId: string, configKey: ConfigurationControllerSetConfigurationConfigKeyEnum, configurationControllerSetConfigurationRequest: ConfigurationControllerSetConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('configurationControllerSetConfiguration', 'orgId', orgId)
            // verify required parameter 'configKey' is not null or undefined
            assertParamExists('configurationControllerSetConfiguration', 'configKey', configKey)
            // verify required parameter 'configurationControllerSetConfigurationRequest' is not null or undefined
            assertParamExists('configurationControllerSetConfiguration', 'configurationControllerSetConfigurationRequest', configurationControllerSetConfigurationRequest)
            const localVarPath = `/msc/organizations/{orgId}/configurations/{configKey}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"configKey"}}`, encodeURIComponent(String(configKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configurationControllerSetConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a test notification to verify Discord configuration. Rate limited to 3 requests per minute.
         * @summary Test Discord notification
         * @param {string} orgId Organization ID (UUID format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerTestDiscordNotification: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('configurationControllerTestDiscordNotification', 'orgId', orgId)
            const localVarPath = `/msc/organizations/{orgId}/configurations/actions/test-discord-notification`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationConfigurationApi - functional programming interface
 * @export
 */
export const OrganizationConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all configuration values for an organization. Sensitive values are masked for security.
         * @summary Get all organization configurations
         * @param {string} orgId Organization ID (UUID format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationControllerGetAllConfigurations(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationControllerGetAllConfigurations(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationConfigurationApi.configurationControllerGetAllConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a specific configuration value for an organization. Use the safe query parameter to get a redacted version of sensitive configurations.
         * @summary Get a specific configuration for an organization
         * @param {string} orgId Organization UUID
         * @param {ConfigurationControllerGetConfigurationConfigKeyEnum} configKey Configuration key
         * @param {boolean} [safe] Return safe (redacted) version of sensitive configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationControllerGetConfiguration(orgId: string, configKey: ConfigurationControllerGetConfigurationConfigKeyEnum, safe?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationControllerGetConfiguration(orgId, configKey, safe, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationConfigurationApi.configurationControllerGetConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set multiple configuration values for an organization in a single request
         * @summary Set multiple organization configurations
         * @param {string} orgId Organization ID (UUID format)
         * @param {BatchConfigurationDto} batchConfigurationDto Array of configurations to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationControllerSetBatchConfigurations(orgId: string, batchConfigurationDto: BatchConfigurationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationControllerSetBatchConfigurations(orgId, batchConfigurationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationConfigurationApi.configurationControllerSetBatchConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set or update a configuration value for an organization.
         * @summary Set a configuration for an organization
         * @param {string} orgId Organization UUID
         * @param {ConfigurationControllerSetConfigurationConfigKeyEnum} configKey Configuration key
         * @param {ConfigurationControllerSetConfigurationRequest} configurationControllerSetConfigurationRequest Configuration value to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationControllerSetConfiguration(orgId: string, configKey: ConfigurationControllerSetConfigurationConfigKeyEnum, configurationControllerSetConfigurationRequest: ConfigurationControllerSetConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigurationActionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationControllerSetConfiguration(orgId, configKey, configurationControllerSetConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationConfigurationApi.configurationControllerSetConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a test notification to verify Discord configuration. Rate limited to 3 requests per minute.
         * @summary Test Discord notification
         * @param {string} orgId Organization ID (UUID format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationControllerTestDiscordNotification(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationControllerTestDiscordNotification(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationConfigurationApi.configurationControllerTestDiscordNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationConfigurationApi - factory interface
 * @export
 */
export const OrganizationConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationConfigurationApiFp(configuration)
    return {
        /**
         * Retrieve all configuration values for an organization. Sensitive values are masked for security.
         * @summary Get all organization configurations
         * @param {string} orgId Organization ID (UUID format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerGetAllConfigurations(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.configurationControllerGetAllConfigurations(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specific configuration value for an organization. Use the safe query parameter to get a redacted version of sensitive configurations.
         * @summary Get a specific configuration for an organization
         * @param {string} orgId Organization UUID
         * @param {ConfigurationControllerGetConfigurationConfigKeyEnum} configKey Configuration key
         * @param {boolean} [safe] Return safe (redacted) version of sensitive configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerGetConfiguration(orgId: string, configKey: ConfigurationControllerGetConfigurationConfigKeyEnum, safe?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.configurationControllerGetConfiguration(orgId, configKey, safe, options).then((request) => request(axios, basePath));
        },
        /**
         * Set multiple configuration values for an organization in a single request
         * @summary Set multiple organization configurations
         * @param {string} orgId Organization ID (UUID format)
         * @param {BatchConfigurationDto} batchConfigurationDto Array of configurations to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerSetBatchConfigurations(orgId: string, batchConfigurationDto: BatchConfigurationDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.configurationControllerSetBatchConfigurations(orgId, batchConfigurationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or update a configuration value for an organization.
         * @summary Set a configuration for an organization
         * @param {string} orgId Organization UUID
         * @param {ConfigurationControllerSetConfigurationConfigKeyEnum} configKey Configuration key
         * @param {ConfigurationControllerSetConfigurationRequest} configurationControllerSetConfigurationRequest Configuration value to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerSetConfiguration(orgId: string, configKey: ConfigurationControllerSetConfigurationConfigKeyEnum, configurationControllerSetConfigurationRequest: ConfigurationControllerSetConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConfigurationActionResponseDto> {
            return localVarFp.configurationControllerSetConfiguration(orgId, configKey, configurationControllerSetConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a test notification to verify Discord configuration. Rate limited to 3 requests per minute.
         * @summary Test Discord notification
         * @param {string} orgId Organization ID (UUID format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationControllerTestDiscordNotification(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.configurationControllerTestDiscordNotification(orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationConfigurationApi - object-oriented interface
 * @export
 * @class OrganizationConfigurationApi
 * @extends {BaseAPI}
 */
export class OrganizationConfigurationApi extends BaseAPI {
    /**
     * Retrieve all configuration values for an organization. Sensitive values are masked for security.
     * @summary Get all organization configurations
     * @param {string} orgId Organization ID (UUID format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationConfigurationApi
     */
    public configurationControllerGetAllConfigurations(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganizationConfigurationApiFp(this.configuration).configurationControllerGetAllConfigurations(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a specific configuration value for an organization. Use the safe query parameter to get a redacted version of sensitive configurations.
     * @summary Get a specific configuration for an organization
     * @param {string} orgId Organization UUID
     * @param {ConfigurationControllerGetConfigurationConfigKeyEnum} configKey Configuration key
     * @param {boolean} [safe] Return safe (redacted) version of sensitive configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationConfigurationApi
     */
    public configurationControllerGetConfiguration(orgId: string, configKey: ConfigurationControllerGetConfigurationConfigKeyEnum, safe?: boolean, options?: RawAxiosRequestConfig) {
        return OrganizationConfigurationApiFp(this.configuration).configurationControllerGetConfiguration(orgId, configKey, safe, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set multiple configuration values for an organization in a single request
     * @summary Set multiple organization configurations
     * @param {string} orgId Organization ID (UUID format)
     * @param {BatchConfigurationDto} batchConfigurationDto Array of configurations to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationConfigurationApi
     */
    public configurationControllerSetBatchConfigurations(orgId: string, batchConfigurationDto: BatchConfigurationDto, options?: RawAxiosRequestConfig) {
        return OrganizationConfigurationApiFp(this.configuration).configurationControllerSetBatchConfigurations(orgId, batchConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or update a configuration value for an organization.
     * @summary Set a configuration for an organization
     * @param {string} orgId Organization UUID
     * @param {ConfigurationControllerSetConfigurationConfigKeyEnum} configKey Configuration key
     * @param {ConfigurationControllerSetConfigurationRequest} configurationControllerSetConfigurationRequest Configuration value to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationConfigurationApi
     */
    public configurationControllerSetConfiguration(orgId: string, configKey: ConfigurationControllerSetConfigurationConfigKeyEnum, configurationControllerSetConfigurationRequest: ConfigurationControllerSetConfigurationRequest, options?: RawAxiosRequestConfig) {
        return OrganizationConfigurationApiFp(this.configuration).configurationControllerSetConfiguration(orgId, configKey, configurationControllerSetConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a test notification to verify Discord configuration. Rate limited to 3 requests per minute.
     * @summary Test Discord notification
     * @param {string} orgId Organization ID (UUID format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationConfigurationApi
     */
    public configurationControllerTestDiscordNotification(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganizationConfigurationApiFp(this.configuration).configurationControllerTestDiscordNotification(orgId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ConfigurationControllerGetConfigurationConfigKeyEnum = {
    DiscordNotificationHookUrl: 'discord_notification_hook_url',
    DiscordNotificationEnable: 'discord_notification_enable'
} as const;
export type ConfigurationControllerGetConfigurationConfigKeyEnum = typeof ConfigurationControllerGetConfigurationConfigKeyEnum[keyof typeof ConfigurationControllerGetConfigurationConfigKeyEnum];
/**
 * @export
 */
export const ConfigurationControllerSetConfigurationConfigKeyEnum = {
    DiscordNotificationHookUrl: 'discord_notification_hook_url',
    DiscordNotificationEnable: 'discord_notification_enable'
} as const;
export type ConfigurationControllerSetConfigurationConfigKeyEnum = typeof ConfigurationControllerSetConfigurationConfigKeyEnum[keyof typeof ConfigurationControllerSetConfigurationConfigKeyEnum];


